<template>
  <div class="cpmtce">
    <h2 class="title">兼容认证</h2>
    <div class="cpm_cont">
      <div
        class="cpm_item"
        v-for="(item, index) in data_list"
        :key="index"
      >
        <img
          class="cpm_icon"
          :src="`https://todeskcdnspeed.todesk.com/mobile/CmptCertification/${item}`"
          alt=""
          @click="showCertificate(index)"
        />
      </div>
    </div>
    <div class="tip">*点击可查看大图</div>
    <transition name="mask">
      <div
        class="showCertificate"
        @click="
          show_certificate = false;
          allowScroll();
        "
        v-if="show_certificate"
      >
        <div class="bx">
          <img
            @click.stop="
              () => {
                return false;
              }
            "
            :src="`https://todeskcdnspeed.todesk.com/mobile/CmptCertification/${certificate_img}`"
            class="imgCertificate"
            alt="资质证书"
          />
          <img
            src="@/assets/CmptCertification/close@2x.png"
            @click="showCertificate(-1)"
            class="closeCertificate"
            alt="关闭"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show_certificate: false,
      data_list: [
        "tongyong1@2x.png",
        "tongyong2@2x.png",
        "tongxin@2x.png",
        "fangde1@2x.png",
        "fangde2@2x.png",
        "qilin@2x.png",
        "qilin_client.png",
        "qilin_host.png",
      ],
      data_list_pic: [
        "tongyong1_pic@2x.png",
        "tongyong2_pic@2x.png",
        "tongxin_pic@2x.png",
        "fangde1_pic@2x.png",
        "fangde2_pic@2x.png",
        "qilin_pic@2x.png",
        "qilin_client@2x.png",
        "qilin_host@2x.png",
      ],
    };
  },
  methods: {
    showCertificate(index) {
      if (index === -1) {
        // this.allowScroll();
        this.show_certificate = false;
      } else {
        // this.stopScroll();
        this.certificate_img = this.data_list_pic[index];
        this.show_certificate = true;
      }
    },
    //阻止body滚动
    stopScroll() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false });
    },
    allowScroll() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", m, { passive: true });
    },
  },
};
</script>
<style lang="less" scoped>
.cpmtce {
  background: #fff;
  padding-top: 40px;
  padding-bottom: 45px;
  .title {
    text-align: center;
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222429;
  }
  .cpm_cont {
    display: flex;
    justify-content: center;
    margin: auto;
    width: 100%;
    margin-top: 60px;
    flex-flow: row wrap;
    .cpm_item {
      width: 110px;
      margin-left: 7px;
      margin-bottom: 12px;
      .cpm_icon {
        width: 100%;
      }
    }
  }
  .tip {
    text-align: center;
    color: #90959c;
  }
}
.showCertificate {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 9, 23, 0.69);
  z-index: 10;
  .bx {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 80%;
    margin: 0 auto;
    .imgCertificate {
      width: 100%;
      // height: 520px;
    }
    .closeCertificate {
      position: relative;
      width: 20px;
      height: auto;
      left: 20px;
      top: -250px;
      cursor: pointer;
    }
  }
}
</style>
